module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/HbxbLV/tc-custom/9781620069769.jpg?1705766050881",
      "alt": "This image is the cover for the book Leviticus Mission, RV Mysteries"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Leviticus Mission, RV Mysteries\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_c('b', [_vm._v("A retired Louisiana cop and his wife hit the road in their RV but must pull over to investigate a serial killer in this mystery series debut.")])]), _c('p', [_vm._v(" Recently retired homicide detective Hank Moran and his wife Helen have just purchased a new motorhome and are ready to take a two-month tour to see the country. The discovery of a series of murders on their short trial run to Biloxi, Mississippi, puts their tour on hold while Hank investigates. ")]), _c('p', [_vm._v(" The prime suspect is a firebrand tent revival preacher who literally takes God’s word for the Old Testament punishment of evildoers. ")]), _c('p', [_vm._v(" Their adventure takes them, of all places, into a gay men’s RV resort for the explosive finale. ")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      L. D. Knorr\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("L.D. Knorr was born and raised on a dairy farm in Berks County Pennsylvania and now resides in rural Alabama. His profession as a mechanical engineer required his relocation from Pennsylvania to Mississippi, Texas, and Alabama. He honed his writing skills on engineering-related technical papers and reports. Now being retired he is focusing his attention on fiction. He travels in his RV trailer with his wife Emily to visit family in Pennsylvania and Mississippi and travels to wherever adventure beckons. They have been married over fifty years and were blessed with three fantastic and creative children.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0